import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactElement } from 'react';
import { ReactComponent as Icon } from '../../assets/icons/icon-container.svg';

export default function Container(props: SvgIconProps): ReactElement {
  return <SvgIcon component={Icon} {...props} />;
}
